var play_icon_default = {
  "shadow": "BfT4Z",
  "playIcon": "Z3kg0"
};
export {
  play_icon_default as default
};
//# sourceMappingURL=play-icon-scss.js.map
